@if (open) {
<div class="modal-backdrop fade show"></div>
<div class="modal fade show detail-modal" tabindex="-1" aria-modal="true" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        @if (isCreateMode()) {
        <h2 class="modal-title">{{ 'pages.clients.modal.create-title' | translate }}</h2>
        } @else {
        <h2 class="modal-title">{{ 'pages.clients.modal.edit-title' | translate }}</h2>
        }

        <button class="btn-close" type="button" (click)="closeDetailModal()"></button>
      </div>

      <form class="modal-body form-grid" [formGroup]="form" (ngSubmit)="save()">
        @if (preselectedAccountId === null) {
        <div class="field-block">
          <label class="form-label" for="account-selector">{{ 'pages.clients.fields.account' | translate }}</label>
          <select class="form-select" [disabled]="saving() || deleting()" id="account-selector"
            [value]="selectedAccountId() ?? ''" (change)="onAccountSelectionChange($event)">
            <option value="">{{ 'pages.clients.accounts.select-placeholder' | translate }}</option>
            @for (account of availableAccounts(); track account.id ?? account.name) {
            <option [value]="account.id ?? ''">{{ account.name }}</option>
            }
          </select>
        </div>
        }

        <app-input-block [invalid]="isInvalid('clientId')" [readonly]="isEditMode()" controlId="client-id"
          controlName="clientId" labelKey="pages.clients.fields.client-id">
          @if (hasError('clientId', 'required') && isInvalid('clientId')) {
          <div class="invalid-feedback">{{ 'pages.clients.validation.client-id-required' | translate }}</div>
          }
          @if (hasError('clientId', 'maxlength') && isInvalid('clientId')) {
          <div class="invalid-feedback">{{ 'pages.clients.validation.client-id-maxlength' | translate }}</div>
          }
          @if (hasError('clientId', 'pattern') && isInvalid('clientId')) {
          <div class="invalid-feedback">{{ 'pages.clients.validation.client-id-pattern' | translate }}</div>
          }
        </app-input-block>

        <app-input-block [invalid]="isInvalid('description')" controlId="description" controlName="description"
          labelKey="pages.clients.fields.description">
          @if (hasError('description', 'maxlength') && isInvalid('description')) {
          <div class="invalid-feedback">{{ 'pages.clients.validation.description-maxlength' | translate }}</div>
          }
        </app-input-block>

        <div class="field-block">
          <label class="form-label" for="application-selector">{{ 'pages.clients.fields.application' | translate
            }}</label>
          <select class="form-select" [disabled]="saving() || deleting() || isEditMode()" id="application-selector"
            [value]="selectedApplicationId() ?? ''" (change)="onApplicationSelectionChange($event)">
            <option value="">{{ 'pages.clients.applications.select-placeholder' | translate }}</option>
            @for (application of availableApplications(); track application.id ?? application.code) {
            <option [value]="application.id ?? ''">{{ application.code }} / {{ application.name }}</option>
            }
          </select>
          @if (submitted() && selectedApplicationId() === null) {
          <div class="invalid-feedback d-block">{{ 'pages.clients.validation.application-required' | translate }}</div>
          }
        </div>

        @if (canChooseType()) {
        <div class="field-block">
          <label class="form-label" for="type-selector">{{ 'pages.clients.fields.type' | translate }}</label>
          <select class="form-select" id="type-selector" [disabled]="saving() || deleting()" [value]="oauthClientType()"
            (change)="onTypeSelectionChange($event)">
            <option value="PUBLIC">{{ 'pages.clients.types.public' | translate }}</option>
            <option value="CONFIDENTIAL">{{ 'pages.clients.types.confidential' | translate }}</option>
          </select>
        </div>
        } @else {
        <app-input-block [readonly]="true" [value]="oauthTypeLabelKey() | translate" controlId="type"
          labelKey="pages.clients.fields.type" />
        }

        @if (isEditMode()) {

        @if(oauthClientType()==='CONFIDENTIAL'){
        <div class="field-block field-block-full">
          <label class="form-label" for="role-selector">{{ 'pages.clients.fields.roles' | translate }}</label>
          <div class="input-group">
            <select class="form-select" [disabled]="saving() || deleting()" id="role-selector"
              [value]="selectedRoleId() ?? ''" (change)="onRoleSelectionChange($event)">
              <option value="">{{ 'pages.clients.roles.select-placeholder' | translate }}</option>
              @for (role of selectableRoles(); track role.id ?? role.code) {
              <option [value]="role.id ?? ''">{{ role.code }}</option>
              }
            </select>
            <button class="btn btn-light" [disabled]="selectedRoleId() === null || saving() || deleting()" type="button"
              (click)="addSelectedRole()">
              <i class="fa-solid fa-plus" aria-hidden="true"></i>
              {{ 'pages.clients.roles.add' | translate }}
            </button>
          </div>
          <div class="d-flex flex-wrap gap-2 mt-2">
            <button class="btn btn-secondary btn-sm" [disabled]="saving() || deleting()" type="button"
              (click)="selectAllRoles()">
              {{ 'pages.clients.roles.select-all' | translate }}
            </button>
            <button class="btn btn-secondary btn-sm" [disabled]="saving() || deleting() || roles().length === 0"
              type="button" (click)="unselectAllRoles()">
              {{ 'pages.clients.roles.unselect-all' | translate }}
            </button>
          </div>
          @if (roles().length === 0) {
          <div class="roles-empty mt-2">{{ 'pages.clients.roles.empty' | translate }}</div>
          } @else {
          <ul class="roles-list mt-2">
            @for (role of roles(); track role.id ?? role.code) {
            <li class="role-item">
              <span class="role-alias">{{ role.code }}</span>
              @if (role.id !== null) {
              <button class="btn btn-light btn-sm" [disabled]="saving() || deleting()" type="button"
                (click)="removeRole(role.id)">
                <i class="fa-solid fa-xmark" aria-hidden="true"></i>
                {{ 'pages.clients.roles.remove' | translate }}
              </button>
              }
            </li>
            }
          </ul>
          }
        </div>
        }

        <div class="field-block field-block-full">
          <div class="form-check form-switch auth-client-switch">
            <input class="form-check-input" [checked]="oauthEnabled()" [disabled]="oauthToggleDisabled()"
              id="authorization-client-enabled" type="checkbox" (change)="onAuthorizationEnabledChange($event)" />
            <label class="form-check-label" for="authorization-client-enabled">
              {{ 'pages.clients.fields.oauth-enabled' | translate }}
            </label>
          </div>
        </div>

        <app-input-block [readonly]="true" [value]="selectedCreatedAt()" controlId="created-at"
          labelKey="pages.clients.fields.created-at" />

        <app-input-block [readonly]="true" [value]="selectedUpdatedAt()" controlId="updated-at"
          labelKey="pages.clients.fields.updated-at" />
        }
      </form>

      <div class="modal-footer">
        @if (isEditMode()) {
        <button class="btn btn-light btn-danger-soft me-auto" [disabled]="saving() || deleting()" type="button"
          (click)="requestDelete()">
          <i class="fa-solid fa-trash" aria-hidden="true"></i>
          {{ 'pages.clients.actions.delete' | translate }}
        </button>
        }

        <button class="btn btn-light" [disabled]="saving() || deleting()" type="button" (click)="closeDetailModal()">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
          {{ 'pages.clients.actions.cancel' | translate }}
        </button>

        <button class="btn btn-primary" [disabled]="saving() || deleting()" type="button" (click)="save()">
          <i class="fa-solid fa-floppy-disk" aria-hidden="true"></i>
          {{ 'pages.clients.actions.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
}